module.exports = __webpack_public_path__ + "2e395b742dcb17b8e8face524592c97b.svg";